import { toUniversalFormat } from '@/utils/dateutils'

export function toLocalString(date) {
  return toUniversalFormat(date)
}

export function dateFormat(fmt, date) {
  let ret
  const opt = {
    'y+': date.getUTCFullYear().toString(),
    'M+': (date.getUTCMonth() + 1).toString(),
    'd+': date.getUTCDate().toString(),
    'H+': date.getUTCHours().toString(),
    'm+': date.getUTCMinutes().toString(),
    'S+': date.getUTCSeconds().toString()
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      )
    }
  }
  return fmt
}

export function storageUnit(size) {
  if (size > 1 * 1024 * 1024 * 1024) {
    return 'GB'
  } else if (size > 1 * 1024 * 1024) {
    return 'MB'
  } else if (size > 1 * 1024) {
    return 'KB'
  } else {
    return 'B'
  }
}

export function formatStorage(size, unit) {
  if (unit === 'GB') {
    return size / 1024 / 1024 / 1024
  } else if (unit === 'MB') {
    return size / 1024 / 1024
  } else if (unit === 'KB') {
    return size / 1024
  } else {
    return size
  }
}

export function formatStorageSizeAsHumanReadable(sizeInBytes) {
  let data
  if (sizeInBytes < 0.1 * 1024) {
    data = sizeInBytes.toFixed(2) + ' B'
  } else if (sizeInBytes < 0.1 * 1024 * 1024) {
    data = (sizeInBytes / 1024).toFixed(2) + ' KB'
  } else if (sizeInBytes < 0.1 * 1024 * 1024 * 1024) {
    data = (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB'
  } else if (sizeInBytes < 0.1 * 1024 * 1024 * 1024 * 1024) {
    data = (sizeInBytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
  } else {
    data = (sizeInBytes / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' TB'
  }
  const sizestr = data + ''
  const len = sizestr.indexOf('\\.')
  const dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

export function getReadableFileSizeString(fileSizeInBytes) {
  let i = -1
  const byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB']
  do {
    fileSizeInBytes /= 1024
    i++
  } while (fileSizeInBytes > 1024)

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i]
}

export function printPrettyJson(value) {
  if (typeof value !== 'object') {
    return ''
  }
  return JSON.stringify(value, null, 2)
}

export function formatNumberAsBitSplit(value) {
  const b = parseInt(value).toString()
  const len = b.length
  if (len <= 3) {
    return b
  }
  const r = len % 3
  // b.slice(r,len).match(/\d{3}/g).join(",") 每三位数加一个逗号。
  return r > 0
    ? b.slice(0, r) + ',' + b.slice(r, len).match(/\d{3}/g).join(',')
    : b.slice(r, len).match(/\d{3}/g).join(',')
}

export function formatMillisecondAsHumanReadable(millis) {
  if (typeof millis === 'string') {
    millis = parseInt(millis)
  }
  if (millis === 0) {
    return '0'
  }
  const hours = Math.floor(millis / 3600000)
  let str = ''
  let slotCount = 0
  if (hours > 0) {
    str = str + `${hours}h`
    slotCount++
  }
  const minutes = Math.floor((millis - hours * 3600000) / 60000)
  if (minutes > 0) {
    str = str + `${minutes}m`
    slotCount++
  }
  if (slotCount >= 2) {
    return str
  }
  const seconds = Math.floor(
    (millis - hours * 3600000 - minutes * 60000) / 1000
  )
  if (seconds > 0) {
    str = str + `${seconds}s`
    slotCount++
  }
  if (slotCount >= 2) {
    return str
  }
  return str === '' ? `${millis}ms` : str
}
